import moment from "moment";

import { AdminJob, AdminJobRecoveryResult } from "../../../../services";
import { formatObservedAt } from "../../utils/format";

const formatDate = (date: string): string =>
  moment.utc(date).format("D MMM YYYY");

export const keyOfJob = ({ kind, id }: AdminJob): string => `${kind}:${id}`;

export const isPreHorizonBlocked = ({
  state,
  isPreHorizon,
}: AdminJob): boolean => state === "coverage_blocked" && isPreHorizon;

export const rangeOfJob = ({ kind, rangeFrom, rangeTo }: AdminJob): string =>
  kind === "snapshot"
    ? moment.utc(rangeTo).format("MMMM YYYY")
    : `${formatDate(rangeFrom)} – ${formatDate(rangeTo)}`;

export const titleOfJob = (job: AdminJob): string =>
  job.instrument ? job.instrument.symbol : `Snapshot · ${rangeOfJob(job)}`;

export const subjectOfJob = ({ instrument, userId }: AdminJob): string =>
  instrument ? `${instrument.symbol} · ${instrument.name}` : `User #${userId}`;

export const recoveryLabelOf = ({
  kind,
  state,
  status,
}: AdminJob): string | null => {
  if (kind === "backfill" && status === "exhausted") {
    return "Retry backfill";
  }
  if (kind === "snapshot" && state === "coverage_blocked") {
    return "Recalculate snapshot";
  }
  return null;
};

export const recoveryMessageOf = (
  { kind }: AdminJob,
  { outcome, jobId }: AdminJobRecoveryResult,
): string => {
  if (outcome === "nothing_to_do") {
    return "Every month in this range already has a price, so nothing was queued.";
  }
  if (outcome === "already_queued") {
    return `Already queued as job #${jobId}, so nothing was added.`;
  }
  return kind === "backfill"
    ? `Retry queued as job #${jobId}. Coverage isn't repaired until it finishes.`
    : "Recalculation queued. It will block again if prices are still missing.";
};

export const formatOptionalTime = (
  time: string | null,
  fallback: string,
): string => (time ? formatObservedAt(time) : fallback);
